<script setup>
import { computed } from 'vue';
import { useKanbanAttribute } from 'dashboard/composables/useKanbanAttribute';
import Label from 'dashboard/components-next/label/Label.vue';

const props = defineProps({
  contact: {
    type: Object,
    default: () => ({}),
  },
});

const { hasKanbanAttribute, kanbanAttributeKey } = useKanbanAttribute();

const laneValue = computed(
  () => props.contact?.custom_attributes?.[kanbanAttributeKey.value] || ''
);

const showBadge = computed(() => hasKanbanAttribute.value && !!laneValue.value);
</script>

<template>
  <Label v-if="showBadge" :label="laneValue" compact color="iris" />
</template>
